module.exports = __webpack_public_path__ + "static/media/pcs-array.c55e4575.png";